namespace Matrix.Data {
    export namespace DataExplorerService {
        export const baseUrl = 'Data/DataExplorer';

        export declare function List(request: DataExplorerListRequest, onSuccess?: (response: Serenity.ListResponse<{ [key: string]: any }>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Data/DataExplorer/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>DataExplorerService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
